import { useRecordPmfActivity as _useRecordPmfActivity } from '@griply/hooks';
import { useUpdateUserMutation } from 'shared/hooks/queries/use-update-user-mutation';
import { useUser } from 'shared/hooks/use-user';

export const useRecordPmfActivity = () => {
  const user = useUser();
  const { mutate: updateUser } = useUpdateUserMutation();

  return _useRecordPmfActivity(user, updateUser);
};
